import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type MessageTemplateMessages = ActionButtonMessages &
  SidebarMessages & {
    pageTitle: string;
    updatePageTitle: string;
    tableTitle: string;
    rowsPerPage: string;

    idColumn: string;
    platformColumn: string;
    nameColumn: string;
    typeColumn: string;
    statusColumn: string;
    sourceIdColumn: string;
    externalIdColumn: string;
    rowDateColumn: string;
    deletedDateColumn: string;
    notificationOnColumn: string;
    optionsColumn: string;

    filterNameLabel: string;
    filterTypeLabel: string;
    filterStatusLabel: string;
    filterButton: string;
    clearFiltersButton: string;

    editButton: string;
    textLabel: string;
    messageTemplateLabel: string;
    availableVariablesTitle: string;
    availableVariablesDescription: string;
    previewTitle: string;
    legacyTypeWarning: string;
    readOnlyInfo: string;

    errorToLoad: string;
    notFoundError: string;
    notFoundDescription: string;
    notFoundAlt: string;
    updateSuccess: string;
    updateError: string;
  };

export const MESSAGE_TEMPLATE_MESSAGES: MessageTemplateMessages = {
  pageTitle: "Modelos transacionais",
  updatePageTitle: "Editar modelo transacional",
  tableTitle: "Listagem de modelos transacionais",
  rowsPerPage: "Linhas por página",

  idColumn: "ID",
  platformColumn: "Plataforma",
  nameColumn: "Nome",
  typeColumn: "Tipo",
  statusColumn: "Status",
  sourceIdColumn: "ID da origem",
  externalIdColumn: "ID do template na plataforma",
  rowDateColumn: "Data de criação",
  deletedDateColumn: "Data de exclusão",
  notificationOnColumn: "Enviar notificação",
  optionsColumn: "Opções",

  filterNameLabel: "Nome",
  filterTypeLabel: "Tipo",
  filterStatusLabel: "Status",
  filterButton: "Filtrar",
  clearFiltersButton: "Limpar",

  editButton: "Editar",
  textLabel: "Texto do template",
  messageTemplateLabel: "Mensagem do template",
  availableVariablesTitle: "Variáveis disponíveis",
  availableVariablesDescription: "Clique em uma variável para inseri-la no campo.",
  previewTitle: "Pré-visualização",
  legacyTypeWarning:
    "Este template está descontinuado. Utilize os templates por status do pedido (CONTACTORDERSTATUS_C, _P, _H, _I, _S, _D, _L).",
  readOnlyInfo: "Somente os campos Texto do template e Mensagem do template podem ser alterados.",

  errorToLoad: "Erro ao carregar os templates",
  notFoundError: "Nenhum template encontrado",
  notFoundDescription: "Não há templates para os filtros informados.",
  notFoundAlt: "Nenhum template encontrado",
  updateSuccess: "Template atualizado com sucesso!",
  updateError: "Erro ao atualizar o template",

  ...ACTION_BUTTON_MESSAGES,
  ...SIDEBAR_MESSAGES,
};
